import { Component,OnInit,AfterViewInit, ChangeDetectorRef, OnDestroy, NgZone, HostListener } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './app-service/auth.service';
import { SharedService } from './app-service/shared.service';
import { NewEntryScannerComponent } from './new-entry-scanner/new-entry-scanner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit,OnDestroy{
   mediaSub: Subscription;
   deviceXs:boolean;
  login= false;
  timeOut=`${environment.timeOut}`;
  userActivity:any;
  userInactive: Subject<any> = new Subject();
  plusimg:string="assets/images/fplus.png";
  homeimg:string="assets/images/home.png";
  moreimg:string="assets/images/menu.png";
  logoutimg:string="assets/images/logout.png";
  constructor (public mediaObserver:MediaObserver,private zone: NgZone,
    public dialog:MatDialog,private authService:AuthService,
     private router: Router,private snackBar: MatSnackBar,private sharedService:SharedService) {
    //Added below line to hind footer from Login page
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/') {
          this.login= true;
        } else {
          this.login= false;
        }
      }
    });
  }
  Logout()
  {
     this.authService.logOut()
  }
  onNewJob()
  {
     const dialogConfig=new MatDialogConfig();
    dialogConfig.disableClose=true;    
    const dialogRef=this.dialog.open(NewEntryScannerComponent,{
      panelClass:'app-dialog',

    });
  }
  onJobStatus()
  {
    this.router.navigate(['/workCompleted']);
    localStorage.removeItem('JobId')
  }
  
 ngOnInit()
 {
   
    //this.authService.checkUserislogged()
    // console.log(this.sharedService.tokenExpireDate)
     this.mediaSub=this.mediaObserver.media$.subscribe((result:MediaChange)=>{
       //console.log(result.mqAlias);
       this.deviceXs=result.mqAlias === 'xs' ? true:false;
     });

     this.setTimeout();
     this.userInactive.subscribe(() => {
       this.logOut();
     }); 
 }
 setTimeout() {
  //  console.log(this.timeOut)
  this.userActivity = setTimeout(() => {
    if (this.authService.getToken()) {
      //console.log('token available')
      this.userInactive.next(undefined);
     // console.log('logged out');
      this.snackBar.open('Session time out','',{
        duration:1000
      });
    }
  }, parseInt(this.timeOut!));
}

@HostListener('window:mousemove') 
@HostListener('window:mouseup')
refreshUserState() {
  if(this.authService.getToken()){
  //console.log('time refreshed')
  clearTimeout(this.userActivity);
  this.setTimeout();
  }
}

@HostListener('window:keydown', ['$event'])
handleKeyboardEvent(event: KeyboardEvent) {
  if(this.authService.getToken()){
    // console.log('time refreshed')
   // console.log("Key pressed")
    clearTimeout(this.userActivity);
    this.setTimeout();
    }
}

logOut()
{
  this.authService.logOut();
}

ngOnDestroy()
{

  this.mediaSub.unsubscribe();

}

}
